import { defineGraphqlClientOptions } from 'nuxt-graphql-middleware/client-options'
import { useCurrentLanguage, useRuntimeConfig } from '#imports'

export default defineGraphqlClientOptions<{
  // The language.
  l: string
  // The build hash.
  h: string
  // The environment.
  e: 'server' | undefined
}>({
  buildClientContext() {
    // @ts-ignore This is a bug in vue-tsc: It thinks that this is using the server util, which requires the H3Event as an argument.
    const language = useCurrentLanguage()
    const config = useRuntimeConfig()

    return {
      // @ts-ignore See above.
      l: language.value,
      h: config.public.buildHash,
      e: import.meta.server ? 'server' : undefined,
    }
  },
})
